import React from 'react';
import './Skeleton.css';

export const SkeletonBox = ({ width = '100%', height = '20px', className = '' }) => (
  <div 
    className={`skeleton skeleton-box ${className}`}
    style={{ width, height }}
  />
);

export const SkeletonCircle = ({ size = '40px', className = '' }) => (
  <div 
    className={`skeleton skeleton-circle ${className}`}
    style={{ width: size, height: size }}
  />
);

export const SkeletonText = ({ lines = 3, className = '' }) => (
  <div className={`skeleton-text ${className}`}>
    {Array.from({ length: lines }).map((_, i) => (
      <div 
        key={i}
        className="skeleton skeleton-line"
        style={{ 
          width: i === lines - 1 ? '70%' : '100%' 
        }}
      />
    ))}
  </div>
);

export const SkeletonCard = ({ className = '' }) => (
  <div className={`skeleton-card ${className}`}>
    <div className="skeleton-card-header">
      <SkeletonCircle size="48px" />
      <div style={{ flex: 1 }}>
        <SkeletonBox height="16px" width="120px" />
        <SkeletonBox height="12px" width="80px" style={{ marginTop: '8px' }} />
      </div>
    </div>
    <div className="skeleton-card-body">
      <SkeletonText lines={2} />
    </div>
  </div>
);

export const SkeletonSwapCard = () => (
  <div className="skeleton-swap-card">
    <div className="skeleton-swap-header">
      <SkeletonBox width="60px" height="20px" />
      <SkeletonCircle size="32px" />
    </div>
    
    <div className="skeleton-swap-field">
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
        <SkeletonBox width="40px" height="14px" />
        <SkeletonBox width="80px" height="14px" />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <SkeletonCircle size="32px" />
          <SkeletonBox width="60px" height="20px" />
        </div>
        <SkeletonBox width="120px" height="32px" style={{ marginLeft: 'auto' }} />
      </div>
    </div>
    
    <div style={{ display: 'flex', justifyContent: 'center', margin: '16px 0' }}>
      <SkeletonCircle size="40px" />
    </div>
    
    <div className="skeleton-swap-field">
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
        <SkeletonBox width="40px" height="14px" />
        <SkeletonBox width="80px" height="14px" />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <SkeletonCircle size="32px" />
          <SkeletonBox width="60px" height="20px" />
        </div>
        <SkeletonBox width="120px" height="32px" style={{ marginLeft: 'auto' }} />
      </div>
    </div>
    
    <SkeletonBox width="100%" height="48px" style={{ marginTop: '20px', borderRadius: '12px' }} />
  </div>
);

export const SkeletonPoolCard = () => (
  <div className="skeleton-pool-card">
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
      <SkeletonCircle size="56px" />
      <div style={{ flex: 1 }}>
        <SkeletonBox width="100px" height="20px" />
        <SkeletonBox width="60px" height="14px" style={{ marginTop: '6px' }} />
      </div>
      <SkeletonBox width="80px" height="32px" />
    </div>
    
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
      <div>
        <SkeletonBox width="60px" height="12px" />
        <SkeletonBox width="100%" height="20px" style={{ marginTop: '6px' }} />
      </div>
      <div>
        <SkeletonBox width="80px" height="12px" />
        <SkeletonBox width="100%" height="20px" style={{ marginTop: '6px' }} />
      </div>
    </div>
    
    <div style={{ display: 'flex', gap: '8px' }}>
      <SkeletonBox width="50%" height="40px" />
      <SkeletonBox width="50%" height="40px" />
    </div>
  </div>
);
